<template>
    <layout-view navTitle="Фильтры">
      <template v-slot:nav>
        <div class="px-4">
          <checkbox-field class="mb-4" name="Показать удалённые" :value.sync="filter.showDeleted"/>
        </div>
      </template>
      <template v-slot:content="{height}">
        <v-form ref="documentTemplateFields">
            <v-data-table
            name="Поля"
            :headers="headers"
            :items="fields"
            :items-per-page="-1"
            disable-pagination
            hide-default-footer
            dense
            :height="height-90"
            :loading="loadState.isLoading"
            >
              <template v-slot:top>

              <v-toolbar dense elevation="0" color="transparent" max-height="48px">
                <v-toolbar-title class="body-2 font-weight-medium">Поля</v-toolbar-title>
                <v-spacer/>
                <v-btn small depressed color="primary" @click="fields.unshift($tools.copy(emptyField))" :loading="loadState.isLoading">
                  Добавить поле
                  <v-icon right dark>mdi-plus</v-icon>
                </v-btn>
              </v-toolbar>

              </template>    
              <template v-slot:item="{ item, index }">
                  <tr :class="{isInactive: item.status==='deleted'}">
                    <td class="text-wrap">{{ item.id }}</td>
                    <td>
                      <v-text-field label="Ключ" v-model="item.keyName" outlined dense hide-details="auto"/>
                    </td>
                    <td>
                      <v-text-field label="Название" v-model="item.label" outlined dense hide-details="auto"/>
                    </td>
                    <td class="py-2">
                      <autocomplete-single class="mb-0" name="Тип" :items="fieldTypes" :select="fieldTypes.find(i=>i.type===item.type)" @update:select="(v)=>{item.type=v.type}">
                          <template v-slot:customInfo="{item}">
                            {{item.name}}
                          </template>
                          <template v-slot:selectedInfo="{item}">
                            {{item.name}}
                          </template>
                      </autocomplete-single>
                    </td>
                    <td>
                      <template v-if="['SELECT','MULTISELECT','CHECKBOX_LIST'].includes(item.type)">
                        <template v-if="parsedOptions(item.options).length">                         
                          <chip
                            v-for="(opt, idx) in parsedOptions(item.options)"
                            :key="idx"
                            class="text-no-wrap mr-1"
                          >
                            {{ opt.label }}
                            <v-icon x-small @click="item.options = removeOption(parsedOptions(item.options),idx)">mdi-close-circle-outline</v-icon>
                          </chip>
                        </template>
  
                        <v-btn
                          color="primary"
                          text
                          class="px-0"
                          @click="addOptionState.modalOpen(index)"
                        >
                          <tooltip right>
                            <v-icon>mdi-plus</v-icon>
                            <template v-slot:content>
                              Добавить опцию
                            </template>
                          </tooltip>  
                        </v-btn>
                      </template>  
                    </td>
                    <td>
                      <btn-icon-accept v-if="item.status!=='deleted'" @accept="item?.id ? deleteField(item.id) :fields.splice(index, 1)" icon="mdi-trash-can-outline" text="Удалить?"/>
                      <btn-icon-accept v-else @accept="restoreField(item.id)" icon="mdi-restore" text="Восстановить?"/>
                    </td>
                  </tr>
              </template>
          
            </v-data-table>

        </v-form>

        <dialog-editor
            name="Добавить опцию"
            submitText="Добавить"
            :item.sync="addOptionState.modalData"
            disableOverlayClick
            @submit="addOptions()"
        >
        
          <v-textarea
            v-model="addOptionState.modalData1"
            outlined dense auto-grow rows="5" 

            class="my-3"
            hint="Добавьте опции (каждая с новой строки)"
            :placeholder="`опция-1 \nопция-2 \nопция-3 \nи т.д.`"
        >
        </v-textarea>

        </dialog-editor>

        <btn-text-accept name="Сохранить" color="primary" @accept="updateFields()" text="Сохранить изменения?" :loading="loadState.isLoading"/>  
      </template>
  </layout-view>
</template>

<script>
import State from "@/plugins/state";
import Api from "@/Api";
import {FormFieldRules} from "@/plugins/formFieldRules";
import axios from "axios";

import AutocompleteSingle from "@/componentsV2/base/AutocompleteSingle.vue";
import {
  Entity_MrFieldDefinition,
} from "../../../../EntityStoreCacheService";

import LayoutView from "@/components/LayoutView";
import Tooltip from "@/componentsV2/base/Tooltip.vue";
import DialogEditor from "@/componentsV2/base/DialogEditor.vue";
import BtnTextAccept from "@/componentsV2/base/BtnTextAccept.vue";
import BtnIconAccept from "@/componentsV2/base/BtnIconAccept.vue";
import Chip from "@/componentsV2/base/Chip.vue";
import CheckboxField from "@/componentsV2/base/CheckboxField.vue";

export default {
  components: {
    DialogEditor,
    AutocompleteSingle, 
    LayoutView,
    Tooltip,
    BtnTextAccept,
    BtnIconAccept,
    Chip,
    CheckboxField
  },
  data: () => ({
    formFieldRules: FormFieldRules,
    headers: [
      { text: 'ID', value: 'id', class:'text-no-wrap', sortable: false},
      { text: 'Ключ', value: 'keyName', sortable: false},
      { text: 'Название', value: 'label', class:'text-no-wrap', sortable: false},
      { text: 'Тип', value: 'type', width:'300', sortable: false},
      { text: 'Опции',value: 'options', sortable: false},
      { text: ''}
    ],
    filter: {
      showDeleted:false
    },
    loadState: new State(),
    addOptionState: new State(),

    fields: [],
    fieldTypes: [
      {name:'Текст',type:'TEXT'},
      {name:'Номер',type:'NUMBER'},
      {name:'Дата',type:'DATE'},
      {name:'Список',type:'SELECT'},
      {name:'Мультисписок',type:'MULTISELECT'},
      {name:'Флажок',type:'CHECKBOX'},
      {name:'Список флажков',type:'CHECKBOX_LIST'},
      {name:'Блок',type:'BLOCK'},
    ],
    emptyField: {
      keyName: null,
      label: null,
      type: null,
      options: null
    },

    // documentTemplateCategories: [],
    // hfTemplates: [],
    // mrFieldDefinitions: [],
    // mrDocxBlocks: [],
    // emptyTemplateField: {
    //   editable: true, 
    //   sortOrder: 1, 
    //   visibleCondition: null, 
    //   block: null, 
    //   blockId: null, 
    //   definition: null,   
    //   definitionId: null 
    // }
  }),
  mounted() {
    this.height = window.innerHeight - 160;
    this.load()
    this.$tools.misDesktopStatus((v)=>{
      this.misDesktopOnline = v;
    });
  },
  watch:{
    filter: {
      handler() {
        this.load();
      },
      deep: true,
    },
  },
  methods:{
    load(){

     let rb = new Entity_MrFieldDefinition()      
      .selects(Entity_MrFieldDefinition.id)
      .selects(Entity_MrFieldDefinition.constraints)
      .selects(Entity_MrFieldDefinition.egiszCode)
      .selects(Entity_MrFieldDefinition.groupName)
      .selects(Entity_MrFieldDefinition.keyName)
      .selects(Entity_MrFieldDefinition.label)
      .selects(Entity_MrFieldDefinition.options)
      //.selects(Entity_MrFieldDefinition.required)
      .selects(Entity_MrFieldDefinition.sortOrder)
      .selects(Entity_MrFieldDefinition.type)
      .selects(Entity_MrFieldDefinition.status)

      if (!this.filter.showDeleted)
        rb.filterAnd([Entity_MrFieldDefinition.entity, Entity_MrFieldDefinition.status].join('.')+' != ?','deleted')

      rb.page(null) 
      .order(Entity_MrFieldDefinition.sortOrder, true)
      .addStateCallback((v)=>{this.loadState.setRequestBuilderState(v)})
      .request((data)=>{
        this.fields = data.items;
      }, (e)=>{
        console.error(e.response.data.message);
      })

    },
    updateFields() {
      if (!this.$refs.documentTemplateFields.validate()) {
        this.$store.commit('alertWarning', 'Поля формы не заполнены');
        return;
      }

      let formData = new FormData();
      this.fields.forEach((field, index) => {
        Object.keys(field).forEach((key) => {
          formData.append(
            `fields[${index}][${key}]`,
            field[key]
          );
        });
      });

      axios.post(Api.host+'/mr/fields',formData).then(()=>{
        this.load();
      }).catch((e)=>{
        console.error(e.response.data.message);
      });
    },
    deleteField(id) {
      axios.delete(Api.host+'/mr/fields/'+id).then(()=>{
        this.load();
      }).catch((e)=>{
        console.error(e.response.data.message);
      });
    },
    restoreField(id) {
      axios.post(Api.host+'/mr/fields/'+id+'/restore').then(()=>{
        this.load();
      }).catch((e)=>{
        console.error(e.response.data.message);
      });
    },
    parsedOptions(options) {
      if (!options) return ''

      try {
        const parsed = JSON.parse(options)
        return Array.isArray(parsed) ? parsed : ''
      } catch (e) {
        return ''
      }
    },
    addOptions(){
      let field = this.fields[this.addOptionState.modalData]
      const newOptions = this.addOptionState.modalData1
        .split(/\r?\n/)          // разбиваем по переносам строк
        .map(line => line.trim())// убираем пробелы
        .filter(line => line)    // убираем пустые строки
        .map(line => ({ label: line }));

      if (newOptions.length>0)
        field.options = JSON.stringify(field.options ? [...JSON.parse(field.options), ...newOptions] : newOptions);

      this.addOptionState.modalClose();
    },
    removeOption(options,dropIndex) {
      options.splice(dropIndex, 1);

      return  options.length>0 ? JSON.stringify(options) : '';
    }
  }
}
</script>